
import Vue from "vue";
import AIAskCom from "../ShareComponents/AIAskCom.vue";
import { deviceInfoByAi } from "@/assets/js/Types";
import GatewayLogCom from "../ShareComponents/GatewayLogCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import { StoreTypes } from "@/assets/js/Types";
import pageCom from "@/components/PageCom.vue";
export default Vue.extend({
  components: { pageCom, GatewayLogCom, AIAskCom },
  data() {
    return {
      items: [] as any,
      search: null as any,
      currentPage: 1,
      pageSize: 6,
      total: 0,
      choosedItem: [] as string[],
      image: require("@/assets/img/icon/deepseek.png"),
    };
  },
  async mounted() {
    await this.getLights();
  },
  methods: {
    deviceSidClick(sid: string) {
      const dialog: any = this.$refs.lightLogDialog;
      if (dialog) {
        dialog.show(sid);
      }
    },
    async getLights() {
      const ret = await DeviceRequestBill.GetLoops(
        this.search,
        this.currentPage,
        this.pageSize
      );
      this.total = ret.total;
      this.items = ret.data;
    },
    async searchClick() {
      await this.getLights();
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.getLights();
    },
    handleSelectionChange(val: any) {
      this.choosedItem = [];
      val.forEach((x: any) => {
        this.choosedItem.push(x.sid);
      });
    },
    getData() {
      return this.choosedItem;
    },
    aiDevice(obj: any) {
      console.log(obj);
      const current: any = {
        A相电参数: {
          电压: obj.apVol + "V",
          电流: obj.apCur + "A",
          功率: obj.apPower + "w",
        },
        B相电参数: {
          电压: obj.bpVol + "V",
          电流: obj.bpCur + "A",
          功率: obj.bpPower + "w",
        },
        C相电参数: {
          电压: obj.cpVol + "V",
          电流: obj.cpCur + "A",
          功率: obj.cpPower + "w",
        },
        当前总功率: obj.power + "w",
      };
      const projectInfo = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
      const msg = `这是一个智能路灯回路控制器，主要是用于监控3相供电状态以及回路开发状态。
      现在的时间是${new Date().toDateString()},回路控制器应24小时工作。
      这个控制器当前的状态是${obj.online == 0 ? "离线" : "在线"}状态，
      这个控制器的最新上报日志记录如下：${JSON.stringify(current)},
      请分析一下这个设备运行状态。`;
      const dialog: any = this.$refs.aiDialog;
      dialog.open(msg);
    },
  },
});
